import type { AccountContext } from '@prerender/diagnostics-api';

import { ABSENT_VALUE } from './formatMeasuredValue';

export function planLabel(account: AccountContext | null): string {
  return account?.planName ?? account?.plan ?? ABSENT_VALUE;
}

export function accountNameLabel(account: AccountContext | null): string {
  return account?.name ?? ABSENT_VALUE;
}
